import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SaveSlackIntegrationInputClass;
function SaveSlackIntegrationInput() {
  if (SaveSlackIntegrationInputClass === VOID) {
    class $ {
      constructor(partyId, team, channel) {
        this.i6r_1 = partyId;
        this.j6r_1 = team;
        this.k6r_1 = channel;
      }
      toString() {
        return 'SaveSlackIntegrationInput(partyId=' + this.i6r_1.toString() + ', team=' + this.j6r_1 + ', channel=' + this.k6r_1 + ')';
      }
      hashCode() {
        var result = this.i6r_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.j6r_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.k6r_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SaveSlackIntegrationInput()))
          return false;
        if (!this.i6r_1.equals(other.i6r_1))
          return false;
        if (!(this.j6r_1 === other.j6r_1))
          return false;
        if (!(this.k6r_1 === other.k6r_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SaveSlackIntegrationInput');
    SaveSlackIntegrationInputClass = $;
  }
  return SaveSlackIntegrationInputClass;
}
//region block: exports
export {
  SaveSlackIntegrationInput as SaveSlackIntegrationInput3jeifrdutkqgi,
};
//endregion

//# sourceMappingURL=SaveSlackIntegrationInput.mjs.map
